import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App.js";
import "./styles.css";

// PWA: cattura SUBITO l'evento di installabilità (può scattare durante il redirect di login,
// prima che il banner React sia montato). Lo conserviamo in un global che InstallPrompt legge.
declare global {
  // eslint-disable-next-line no-var
  var __kappaInstallPrompt: Event | null;
}
globalThis.__kappaInstallPrompt = null;
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  globalThis.__kappaInstallPrompt = e;
  window.dispatchEvent(new Event("kappa-installable"));
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// PWA: registra il service worker (installabilità). Nessuna cache dei dati.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      /* registrazione SW non disponibile: l'app funziona comunque */
    });
  });
}
